<template>
  <div id="app">
    <router-view />
  </div>
</template>
<script>
export default {
  created(){
    this.$http.interceptors.response.use(undefined,function(err){
      return new Promise(function(resolve, reject){
        if(err.status === 401 && !err.config && !err.config.__isRetryRequest) {
          this.$store.dispatch(logout)
        }
        throw err;
      })
    })
  }
}
</script>
<style>
 @font-face { 
       font-family: "Montserrat";
       src: url("../src/assets/fonts/montserrat/Montserrat-Regular.otf"); 
       font-weight: normal;
   }
html,body,#app{
  height: 100%;
  box-sizing: border-box;
  margin: 0;
}
.padding {
	width: 80%;
	margin-top: 100px;
	margin-bottom: 100px;
}
</style>
